<template>
    <div>
        <!-- Header -->
        <div class="header bg-gradient-info py-7 py-lg-8 pt-lg-9">
            <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                            <h1 class="text-white">Login</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <div class="card bg-secondary border-0 mb-0">
                        <div class="card-body px-lg-5 py-lg-5">
                            <form method="POST" action="#">
                                <base-input alternative
                                            class="mb-3"
                                            prepend-icon="ni ni-email-83"
                                            placeholder="Email"
                                            :error="form.errors.get('email')"
                                            :valid="form.errors.has('email')"
                                            v-model="form.email">
                                </base-input>

                                <base-input alternative
                                            class="mb-3"
                                            prepend-icon="ni ni-lock-circle-open"
                                            type="password"
                                            :error="form.errors.get('password')"
                                            :valid="form.errors.has('password')"
                                            placeholder="Password"
                                            v-model="form.password"
                                            @keyup.enter.native="submit">
                                </base-input>
                                <div class="invalid-feedback" style="display: block;" v-if="authError"
                                     v-text="authError">
                                </div>
                                <div class="text-center">
                                    <base-button type="primary" class="my-4" @click="submit">Sign in</base-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {resourceFactory} from '../../resourceFactory';
    import defineRulesFor from '../../config/rules'
    import Form from '../../form.js';
    import axios from 'axios';

    const auth = resourceFactory.get('auth');

    export default {
        data() {
            return {
                form: new Form({
                    'email': '',
                    'password': '',
                }),
                authError: ''
            };

        },
        methods: {
            submit() {
                axios.get(auth.sanctum()).then(response => {
                    this.form.post(auth.login())
                        .then(response => {

                            // Fetch just logged in user
                            axios.get(auth.user()).then(user => {

                                let routePath = user.data.password_changed_at != null ? '/dashboard' : '/profile'
                                
                                // Register permissions
                                this.$ability.update(defineRulesFor(user.data));

                                this.$router.push(routePath).catch(error => {
                                    console.log(error);
                                });

                            });

                        })
                        .catch(error => {
                            console.log(error);
                            if (error.response.status === 401) {
                                this.authError = error.response.data;
                            } else {
                                this.authError = '';
                            }
                        })
                });
            },
        },
    }
</script>
